import { Box, Button, Container, Divider, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getIntegrations, showIntegration } from '../../../redux/actions/integrations'
import { IRootState } from '../../../redux/types'
import CustomChip from '../../shared/components/CustomChip'
import Header from '../../shared/components/Header'
import ButtonBack from '../../shared/components/buttons/ButtonBack'
import TokentModal from '../../shared/components/modals/TokenModal'
import useScreenWidth from '../../shared/hooks/useScreenWidth'
import SubHeader from '../../shared/styles/Subheader'

function IntegrationsAPI() {
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()

  const { integrations, showForm } = useSelector((state: IRootState) => state.integration)

  useEffect(() => {
    dispatch(getIntegrations())
  }, [])

  return (
    <>
      <Header title="Integraciones" />
      <SubHeader />

      <Container>
        <ButtonBack />
        <Box
          display="flex"
          alignItems="center"
          sx={theme => ({
            paddingTop: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
              padding: theme.spacing(4),
              paddingBottom: theme.spacing(4),
              paddingTop: 0
            }
          })}
        >
          <Divider style={{ flexShrink: 1 }} />
          <Box sx={{ padding: '0px 32px' }}>
            <Typography variant="h6" style={{ minWidth: 'fit-content' }}>
              API
            </Typography>
          </Box>
          <Divider style={{ flexShrink: 1 }} />
        </Box>

        {integrations.map((integration: any) => (
          <Box key={integration.id} mb={25} gap={isMobile ? '24px' : '48px'} flexWrap="wrap">
            <Button
              onClick={() => {
                dispatch(showIntegration(integration.id))
              }}
              variant="contained"
              sx={theme => ({
                color: '#FF4A00',
                backgroundColor: theme.palette.warning.light,
                border: '1px solid #FF4A00',
                height: 110,
                width: '100%',
                [theme.breakpoints.up('sm')]: {
                  maxWidth: 292
                },
                '&:hover': {
                  border: 'transparent',
                  backgroundColor: '#FF4A00',
                  color: theme.palette.common.white
                },
                '& h6': {
                  marginRight: 16
                }
              })}
            >
              <Typography variant="subtitle1">{integration.name}</Typography>
              {integration.status ? <CustomChip type={1} status={0} /> : <CustomChip type={1} status={1} />}
            </Button>
          </Box>
        ))}

        {showForm && <TokentModal stateModal={showForm} />}
      </Container>
    </>
  )
}

export default IntegrationsAPI
